import moment from 'moment'
import { OnSchedTemplates } from '../OnSchedTemplates';

import { OnSchedHelpers }   from '../utils/OnSchedHelpers';


export const availabilityContainer = () => {
  const markup = `
    <div class="onsched-container onsched-availability">
      <div class="onsched-error-container"></div>
      <div id="available-times-row" class="onsched-row">
          <div class="onsched-availability-col">
            <div class="onsched-calendar-container">
              <div class="onsched-calendar"></div>
              ${OnSchedTemplates.TimezoneSearch}
            </div>
          </div>
          <div id="onsched-available-times-col" class="onsched-availability-col">
            <div id="onsched-availability-loading"></div>
            <div id="onsched-available-times" class="onsched-available-times"></div>
          </div>
      </div>
      <div class="onsched-booking-form-container"></div>
    </div>
    <div class="onsched-booking-confirmation-container"></div>
    `;
  return markup;
}

export const timesContainer = (element, availableTimes, locationId, customerId, locale) => {

  locationId = OnSchedHelpers.IsEmpty(locationId) ? "" : locationId;
  customerId = OnSchedHelpers.IsEmpty(customerId) ? "" : customerId;

  const timesHtml = `
      ${availableTimes.map((availableTime, index) => 
        `<li>
            <button class="time onsched-chip hoverable"
            data-location-Id="${locationId}"
            data-customer-Id="${customerId}"
            data-start-Date-Time="${availableTime.startDateTime}"
            data-end-Date-Time="${availableTime.endDateTime}"
            ${
              // check if resourceIds is used
              availableTime.resourceIds && !Boolean(element.params.roundRobin)
              ? 
              `data-resource-Ids="${availableTime.resourceIds}"`
              : 
              `data-resource-Id="${availableTime.resourceId}"`
            }
            data-date="${availableTime.date}"
            data-time="${availableTime.time}"
            data-duration="${availableTime.duration}"
            data-slots="${availableTime.availableBookings}"
            data-allowable-Bookings="${availableTime.allowableBookings}"
            data-allowable-Capacity="${availableTime.allowableCapacity}"
            data-available-Bookings="${availableTime.availableBookings}"
            data-available-Capacity="${availableTime.availableCapacity}"
            data-display-Time="${availableTime.displayTime}"
            data-travel-Appointment-Id="${availableTime.travelAppointmentId}"
            data-travel-Time-Mins="${availableTime.travelTimeMins}"
            title="Click to book now. ${availableTime.allowableCapacity > 0 ? availableTime.availableCapacity : availableTime.availableBookings} remaining"
            >
            ${OnSchedHelpers.timeFromMilitaryTime(availableTime.time, locale)}
            </button>
        </li>`
      ).join("")}
  `;
  return timesHtml;
}

const DatesAreEqual = (date1, date2) => {
    var equal = false;
    if (date1.getFullYear() == date2.getFullYear() && date1.getMonth() == date2.getMonth() && date1.getDate() == date2.getDate())
        equal = true;

    return equal;
}

export const weeklyDateSelector = date => {
  var options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };

  // Here I need the logic to build out the weekdays
  // First from the date passed in figure out the day of the week
  var selectedDate = new Date(date);
  var workingDate = new Date(date);
  var dow = date.getDay();
  var weekStartDate = OnSchedHelpers.AddDaysToDate(workingDate, -dow);
  var week = [];
  var weekDayDate = weekStartDate;
  for (i = 0; i < 7; i++) {
      weekDayDate = OnSchedHelpers.AddDaysToDate(weekStartDate, i);
      week.push(weekDayDate);
  }

  var dayOptions = { weekday: 'short' };

  const htmlWeekdaySelector = `
      <div class="onsched-weekday-selector">
          <table cellpadding="0" cellspacing="0" role="grid">
              <tbody>
                  <tr>
                  ${week.map((date, index) =>
          `<td aria-selected="true" data-day="${date.getDay()}" class="${DatesAreEqual(selectedDate, date) ? 'selected' : ''}">
                          <button data-day="${date.getDay()}" data-date="${date}" class="datepicker-day-button" class="waves-effect">
                              ${week[index].toLocaleDateString("en-US", dayOptions)}</button>
                      </td>`
      ).join("")}
                  </tr>
              </tbody>
          </table>
      </div>
  `;

  const htmlDatePicker = `
  <div class="onsched-datepicker-week">
      <div class="onsched-week-selector" role="heading" aria-live="assertive">
          <button class="week-prev" type="button" disabled="disabled" title="Previous week">
              <span class="chevron">&#10094;</span>
          </button>
          <div class="date-selected">${date.toLocaleDateString("en-US", options)}</div>
          <button class="week-next" type="button" title="Next week">
              <span class="chevron">&#10095;</span>
          </button>
      </div>
      ${htmlWeekdaySelector}
  </div>
  `;

  html = htmlDatePicker;

  return html;
}

const multiResourceTimesFilter = (availableTimes, resourceIds) => {
  let matched = [];

  availableTimes.forEach(time => {
    // check if the number of times the same time exists equals the number of resourceIds
    const timeInstanceCount = availableTimes.map(t => t.time).filter(t => t === time.time).length
    const matchingTimes = timeInstanceCount === resourceIds.split(',').length;

    if (matchingTimes) {
      // check if time is unique
      if (matched.filter(m => m.time === time.time).length === 0) {
        // remove the resourceId property and replace with resourceIds, then add to array
        let match = time;
        delete match.resourceId;
        match.resourceIds = resourceIds;
        
        matched.push(match);
      }
    }
  })

  return matched;
}

export const availableTimes2 = (element, response, selectedDate) => {
  const { params: { customerId, groupSize = 0 }, onsched: { locale } } = element;
  const { locationId } = response;

  let availableTimes = response.availableTimes;
  let allAvailableTimes = response.availableTimes;

  const htmlNoAvailableTimes = `
      <div class="onsched-no-available-times">
          <p>
              <i class="far fa-clock"></i>
              No available times
          </p>
      </div>
  `;

  if (availableTimes.length == 0)
      return htmlNoAvailableTimes;

//   if (element.params.fullAvailabilityDays) {
//     availableTimes = availableTimes.filter(a => a.date === OnSchedHelpers.CreateDateString(selectedDate));
//   }

  // check for multiple resource ids and matching times option
  let resourceIds = [...new Set(availableTimes.map(t => t.resourceId))].join(',');

  if (element.options.findMatchingTimes) {
    availableTimes = multiResourceTimesFilter(availableTimes, resourceIds);
  }

  // Rearrange times in ascending order
  availableTimes.sort((p1, p2) => (p2.time < p1.time) ? 1 : (p2.time > p1.time) ? -1 : 0);

  // bust up times into morning, afternoon and evening
  var morning = []; // < 1200
  var afternoon = []; // 1200 to 1800
  var evening = []; // > 1800 

  var capacityTimes = [];

  availableTimes.map(timeslot => {
    const isToday = moment(selectedDate).format('YYYY-MM-DD') === timeslot.date;

    if (isToday) {
      if (timeslot.allowableCapacity > 0) {
          if (groupSize <= timeslot.availableCapacity)
            capacityTimes.push(timeslot)
      }
      else capacityTimes.push(timeslot)
    }
  });

  if (capacityTimes.length == 0)
    return htmlNoAvailableTimes;

  capacityTimes.map(timeslot => {
      if (timeslot.time < 1200) {
          morning.push(timeslot);
      }
      if (timeslot.time >= 1200 && timeslot.time < 1800) {
          afternoon.push(timeslot);
      }
      if (timeslot.time >= 1800) {
          evening.push(timeslot);
      }
  })

  // Display Table of Morning, Afternoon and Evening Times
  // NOTE - any one of these could be empty
  // HOW DO I TEMPLATE THIS?
  // Conditionally generate rows for morning, afternoon, and evening

  const htmlMorningRows = `
    <div class="onsched-times-column">
        <h5>Morning</h5>
        <ul>${timesContainer(element, morning, locationId, customerId, locale)}</ul>
    </div>
  `;
  const htmlAfternoonRows = `
    <div class="onsched-times-column">
        <h5>Afternoon</h5>
        <ul>${timesContainer(element, afternoon, locationId, customerId, locale)}</ul>
    </div>
    `;
  const htmlEveningRows = `
    <div class="onsched-times-column">
        <h5>Evening</h5>
        <ul>${timesContainer(element, evening, locationId, customerId, locale)}</ul>
    </div>
  `;
  const topLevel = response;
  delete topLevel.availableTimes;
  const availableDaysStr = JSON.stringify(topLevel.availableDays).replaceAll('"', '&quot;');
  
  const htmlOtherRows = `
    <div 
        class="hide" 
        id="onsched-hidden-loaded-times"
        data-available-Days="${availableDaysStr}"
        data-business-Name="${topLevel.businessName}"
        data-calendar-Id="${topLevel.calendarId}"
        data-calendar-Resource-Group-Id="${topLevel.calendarResourceGroupId}"
        data-end-Date="${topLevel.endDate}"
        data-first-Available-Date="${topLevel.firstAvailableDate}"
        data-location-Id="${topLevel.locationId}"
        data-object="${topLevel.object}"
        data-resource-Description="${topLevel.resourceDescription}"
        data-resource-Id="${topLevel.resourceId}"
        data-resource-Ids="${topLevel.resourceIds}"
        data-resource-Name="${topLevel.resourceName}"
        data-service-Description="${topLevel.serviceDescription}"
        data-service-Duration="${topLevel.serviceDuration}"
        data-service-Id="${topLevel.serviceId}"
        data-service-Name="${topLevel.serviceName}"
        data-start-Date="${topLevel.startDate}"
        data-timezone-Name="${topLevel.timezoneName}"
        data-tz-Requested="${topLevel.tzRequested}"
        data-url="${topLevel.url}"
    >
        <ul>${timesContainer(element, allAvailableTimes, locationId, customerId, locale)}</ul>
    </div>
  `;

  const html = `
    ${morning.length > 0 ? htmlMorningRows : ''}
    ${afternoon.length > 0 ? htmlAfternoonRows : ''}
    ${evening.length > 0 ? htmlEveningRows : ''}
  `;
    // ${element.params.fullAvailabilityDays && allAvailableTimes.length > 0 ? htmlOtherRows : ''}

  return html;
}

export const availableTimes = response => {

  const timesHtml = `
      <div class="onsched-time-container">
          ${response.availableTimes.map((availableTime, index) =>
          `<a href="#" class="time">
              <div class="onsched-chip hoverable">
                  ${timeFromDisplayTime(availableTime.displayTime)} <span class="ampm">${ampmFromDisplayTime(availableTime.displayTime)}</span>
              </div>
          </a>`
      ).join("")}
      </div>
  `;
  return timesHtml;
}

const getDisplayableWeeks = date => {
    var firstDay = OnSchedHelpers.FirstDayOfMonth(date);
    var lastDay = OnSchedHelpers.LastDayOfMonth(date);

    var dow = firstDay.getDay();
    var displayableMonthDaysWeekOne = 7 - dow;
    var remainingDisplayableDays = lastDay.getDate() - displayableMonthDaysWeekOne;
    var remainingDisplayableWeeks = Math.floor(remainingDisplayableDays / 7) + (remainingDisplayableDays % 7 > 0 ? 1 : 0);
    var totalDisplayableWeeks = remainingDisplayableWeeks + 1;
    return totalDisplayableWeeks;
}

const availableDaysFromDate = date => {
    // build array of availableDays using only a date
    // this can be built quickly before availability call completes

    // How many days to I need. Same as daysToPull calculation
    // Days to pull calculation now going to be all displayableDays
    var firstDate = getFirstDisplayableDate(date);
    var weeks = getDisplayableWeeks(date);
    var displayableDays = weeks * 7;
    //        var lastDate = AddDaysToDate(firstDate, displayableDays);
    // start at firstDate and iterate through until hit last date
    var workingDate = new Date(firstDate);
    var availableDays = [];
    for (var i = 0; i < displayableDays; i++) {
        var availableDay = new OnSchedHelpers.AvailableDay(workingDate);
        availableDays.push(availableDay);
        workingDate = OnSchedHelpers.AddDaysToDate(workingDate, 1);
    }
    return availableDays;
}

const getFirstDisplayableDate = date => {
    // first get the beginning of month
    // then go backwards to sunday
    var firstDayOfMonth = OnSchedHelpers.FirstDayOfMonth(date);
    var dow = firstDayOfMonth.getDay();
    var weekStartDate = OnSchedHelpers.AddDaysToDate(firstDayOfMonth, -dow);
    return weekStartDate;
}

const getAvailableMonthWeeks = (availableDays, date) => {
    // To render the calendar html with templates we need to transform the 
    // available days into an array of weeks of the month.
    var weeksInMonth = getDisplayableWeeks(date);
    var weekStartDate = OnSchedHelpers.ParseDate(availableDays[0].date);
    var monthWeeks = [];
    for (var i = 0; i < weeksInMonth; i++) {
        var week = [];
        for (var j = 0; j < 7; j++) {
            week.push(availableDays[i * 7 + j]);
        }
        weekStartDate = OnSchedHelpers.AddDaysToDate(weekStartDate, 7);
        monthWeeks.push(week);
    }
    return monthWeeks;
}

const getDisabledMonthPrev = availableDays => {
    var today = moment(new Date());
    var firstDay = moment(availableDays[0].date);

    if (firstDay.diff(today, 'days') < 0)
        return "disabled";
    else
        return "";
}

const getDisabledMonthNext = availableDays => {
    var lastDay = availableDays[availableDays.length - 1];
    if (lastDay.reasonCode == 501)
        return "disabled";
    else
        return "";
}

export const calendarSelectorFromDate = (date, locale) => {
  // For a quick render of the calendar
  // we build day availability from the date
  var availableDays = availableDaysFromDate(date);
  return calendarSelector(availableDays, date, locale);
}

export const calendarSelector = (availableDays, date, locale) => {
  var monthWeeks = getAvailableMonthWeeks(availableDays, date);

  const tmplCalendarHeader = `
      <div class="onsched-calendar-header">
        <div class="onsched-service-name"></div>

        <div class="onsched-month-display">
            <i 
                class="month-prev fas fa-caret-left ${getDisabledMonthPrev(availableDays)}"
                title="Previous month" 
                data-firstDay="${availableDays[0].date}"
            >
            </i>
            <div class="onsched-calendar-title" data-month="${date.getMonth()}" data-year="${date.getFullYear()}">
                <span class="short">${moment(date).format('MMM YYYY')}</span>
                <span class="long">${moment(date).format('MMMM YYYY')}</span>
            </div>
            <i 
                data-lastDay="${availableDays[availableDays.length - 1].date}" 
                title="Next month" 
                class="month-next fas fa-caret-right ${getDisabledMonthNext(availableDays)}"
            >
            </i>
        </div>
      </div>
  `;

  var weekdayDate = new Date(2020, 3-1, 1, 0, 0, 0); 

  const tmplCalendarWeekDayRow = `
      <div class="onsched-calendar-row onsched-weekdays">
          <div class="onsched-calendar-col dow" title="${weekdayDate.toLocaleDateString(locale,  {weekday: "long"})}">
              ${weekdayDate.toLocaleDateString(locale,  {weekday: "short"})}
          </div>
          <div class="onsched-calendar-col dow" title="${OnSchedHelpers.AddDaysToDate(weekdayDate, 1).toLocaleDateString(locale,  {weekday: "long"})}">
              ${OnSchedHelpers.AddDaysToDate(weekdayDate, 1).toLocaleDateString(locale,  {weekday: "short"})}
          </div>
          <div class="onsched-calendar-col dow" title="${OnSchedHelpers.AddDaysToDate(weekdayDate, 2).toLocaleDateString(locale,  {weekday: "long"})}">
              ${OnSchedHelpers.AddDaysToDate(weekdayDate, 2).toLocaleDateString(locale,  {weekday: "short"})}
          </div>
          <div class="onsched-calendar-col dow" title="${OnSchedHelpers.AddDaysToDate(weekdayDate, 3).toLocaleDateString(locale,  {weekday: "long"})}">
              ${OnSchedHelpers.AddDaysToDate(weekdayDate, 3).toLocaleDateString(locale,  {weekday: "short"})}
          </div>
          <div class="onsched-calendar-col dow" title="${OnSchedHelpers.AddDaysToDate(weekdayDate, 4).toLocaleDateString(locale,  {weekday: "long"})}">
              ${OnSchedHelpers.AddDaysToDate(weekdayDate, 4).toLocaleDateString(locale,  {weekday: "short"})}
          </div>
          <div class="onsched-calendar-col dow" title="${OnSchedHelpers.AddDaysToDate(weekdayDate, 5).toLocaleDateString(locale,  {weekday: "long"})}">
              ${OnSchedHelpers.AddDaysToDate(weekdayDate, 5).toLocaleDateString(locale,  {weekday: "short"})}
          </div>
          <div class="onsched-calendar-col dow" title="${OnSchedHelpers.AddDaysToDate(weekdayDate, 6).toLocaleDateString(locale,  {weekday: "long"})}">
              ${OnSchedHelpers.AddDaysToDate(weekdayDate, 6).toLocaleDateString(locale,  {weekday: "short"})}
          </div>
      </div>
  `;

  const tmplCalendarWeekRow = days => `
  <div class="onsched-calendar-row">
  ${days.map(day => `
      <div class="onsched-calendar-col">
          <button class="day ${OnSchedHelpers.IsSelected(day, date)}" data-date="${day.date}" ${OnSchedHelpers.IsAvailable(day)} title="${day.reason}">${OnSchedHelpers.ParseDate(day.date).getDate()}</button>
      </div>
  `).join('')}
  </div>
  `;
  const tmplCalendarGrid = weeks => `
  <div class="onsched-calendar-grid">
  ${tmplCalendarWeekDayRow}
      <div class="onsched-calendar-rowgroup">
      ${weeks.map(week => `
          ${tmplCalendarWeekRow(week)}
      `).join('')}        
      </div>
  </div>
  `;

  const tmplCalendar = `
      ${tmplCalendarHeader}
      ${tmplCalendarGrid(monthWeeks)}
  `;

  return tmplCalendar;
}

const TzUtcTime = (tzData, date) => {
    var today = new Date();
    date = date == undefined ? today : date;
    for (var i = 0; i < tzData.length; i++) {
        var m = moment.tz(date, tzData[i].id);
        tzData[i].name += " " + "(UTC" + m.format("Z") + ")";
        tzData[i].offset = m.utcOffset();
    }
    return tzData;
}

    const TzUsCanada = date => {

    var tzData = [

        { "name": "Pacific Time", "id": "America/Los_Angeles", "offset": "0"},
        { "name": "Mountain Time", "id": "America/Denver", "offset": "0" },
        { "name": "Central Time", "id": "America/Chicago", "offset": "0" },
        { "name": "Eastern Time", "id": "America/New_York", "offset": "0" },
        { "name": "Alaska Time", "id": "America/Anchorage", "offset": "0" },
        { "name": "Hawaii Time", "id": "Pacific/Honolulu", "offset": "0" },
        { "name": "Atlantic Time", "id": "America/Halifax", "offset": "0" },
        { "name": "Newfoundland Time", "id": "America/St_Johns", "offset": "0" }
    ];

    return TzUtcTime(tzData, date);
}
const TzEurope = date => {
    var tzData = [

        { "name": "UK,Ireland,Lisbon", "id": "Europe/London", "offset": "0" },
        { "name": "Central European Time", "id": "Europe/Madrid", "offset": "0" },
        { "name": "Eastern European Time", "id": "Europe/Bucharest", "offset": "0" },
        { "name": "Minsk Time", "id": "Europe/Minsk", "offset": "0" },
    ];
    return TzUtcTime(tzData, date);
}
const TzAustralia = date => {
    var tzData = [

        { "name": "Australian Western Time", "id": "Australia/Perth", "offset": "0" },
        { "name": "Australian Central Western Time", "id": "Australia/Eucla", "offset": "0" },
        { "name": "Austrailian Adelaide Time", "id": "Australia/Adelaide", "offset": "0" },
        { "name": "Austrailian Brisbane Time", "id": "Australia/Brisbane", "offset": "0" },
        { "name": "Austrailian Eastern Time", "id": "Australia/Sydney", "offset": "0" },
        { "name": "Austrailian Lord Howe Time", "id": "Australia/Lord_Howe", "offset": "0" },
    ];
    return TzUtcTime(tzData, date);
}

export const Timezones = date => {
  var tzRegionData = [
      { "name": "US / Canada", "timezones": TzUsCanada(date) },
      { "name": "Europe", "timezones": TzEurope(date) },
      { "name": "Australia", "timezones": TzAustralia(date) },
  ];
  return tzRegionData;
}

const BusinessTzOption = value => {
    if (value == undefined) {
        return "";
    }
    else {
        const markup = `
            <option value="">Business Location Timezone</option>
        `;
        return markup;
    }
}

const TimezoneOptionGroups = (name, timezones) => {
    // need to do this template style in onschedjs
    const markup = `
        <li class="onsched-timezone-region" data-tztoggle="false">${name}</li>
        ${timezones.map(timezone =>
        `<li 
            data-tz="${timezone.id}" 
            data-offset="${timezone.offset}" 
            data-tzname="${timezone.name}" 
            class="onsched-timezone-option"
        >
            <span>${timezone.name.slice(0, -12)}</span>
            <span class="onsched-timezone-time-preview">${moment().tz(timezone.id).format('h:mm a')}</span>
        </li>`
        ).join("")}
    `;
    return markup;
}

export const TimezoneSelectOptions = (tzRegionData) => {
  const markup = `
      ${tzRegionData.map((tzRegion, index) =>
          `${TimezoneOptionGroups(tzRegion.name, tzRegion.timezones)}`
      ).join("")}
  `;
  return markup;
}
